import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const ContactPersonForm = forwardRef(({contact, person, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={person}
      type="person"
      fieldsComponent={Fields}
      onSave={useCallback(({first_name, last_name, position, phone, email, is_key, is_accounts}) => (
        services.contact.person.savePerson(contact, {
          ...(person?.id ? {id: person.id} : {}),
          first_name,
          last_name,
          position,
          phone,
          email,
          is_key,
          is_accounts
        })
      ), [services, contact, person])}
      onSaved={onSaved}
    />
  );
});

export default ContactPersonForm;
